export default {
  create_title: 'Webhook-endpoint toevoegen',
  edit_title: 'Webhook-endpoint bewerken',
  form: {
    url: 'HTTPS-endpoint-URL',
    description: 'Omschrijving',
    description_placeholder: 'bijv. Bestelgebeurtenissen voor de kassa',
    events: 'Te leveren gebeurtenissen',
    events_required: 'Selecteer minstens één gebeurtenis.',
    events_hint: 'Alleen de geselecteerde gebeurtenissen worden naar dit eindpunt verzonden.',
    events_selected: '{{selected}} van {{total}}',
    event_groups: {
      order: 'Bestellingen',
      store: 'Winkel',
      product: 'Producten',
      modifier: 'Modifiers',
      menu_push: 'Menu-pushes',
      payout: 'Uitbetalingen',
    },
    status: 'Status',
    status_active: 'Actief',
    status_disabled: 'Uitgeschakeld',
    status_auto_disabled: 'Automatisch uitgeschakeld (kies Actief om opnieuw in te schakelen)',
  },
  buttons: {
    cancel: 'Annuleren',
    create: 'Aanmaken',
    save: 'Opslaan',
  },
  toasts: {
    created: 'Endpoint aangemaakt.',
    updated: 'Endpoint bijgewerkt.',
    error: 'Kan het endpoint niet opslaan. Probeer het opnieuw.',
  },
};
